/**
 * The position. Mostly used for content insertion and traversing
 * On insertion, we will need to specify where we want the content to be placed (begin, end, selection or outside)
 * On content traversing, we will need to specify the start position of traversing
 */
// eslint-disable-next-line etc/no-const-enum
export var ContentPosition;
(function (ContentPosition) {
    /**
     * Begin of the container
     */
    ContentPosition[ContentPosition["Begin"] = 0] = "Begin";
    /**
     * End of the container
     */
    ContentPosition[ContentPosition["End"] = 1] = "End";
    /**
     * End of the content div domain.
     */
    ContentPosition[ContentPosition["DomEnd"] = 2] = "DomEnd";
    /**
     * Selection start
     */
    ContentPosition[ContentPosition["SelectionStart"] = 3] = "SelectionStart";
    /**
     * Outside of editor
     */
    ContentPosition[ContentPosition["Outside"] = 4] = "Outside";
    /**
     * Manually defined range
     */
    ContentPosition[ContentPosition["Range"] = 5] = "Range";
})(ContentPosition || (ContentPosition = {}));
//# sourceMappingURL=ContentPosition.js.map